import { useEffect, useRef } from 'react';

/**
 * Hook that listens for push notification messages from the service worker
 * and plays a notification sound
 */
export function useNotificationSound(soundUrl = '/notification.wav') {
  const audioRef = useRef(null);

  useEffect(() => {
    // Pre-load the audio
    audioRef.current = new Audio(soundUrl);
    audioRef.current.volume = 1.0;

    // Listen for messages from service worker
    const handleMessage = (event) => {
      if (event.data?.type === 'PLAY_NOTIFICATION_SOUND') {
        console.log('[SOUND] Playing notification sound');
        if (audioRef.current) {
          audioRef.current.currentTime = 0;
          audioRef.current.play().catch((err) => {
            console.error('[SOUND] Failed to play:', err);
          });
        }
      }
    };

    navigator.serviceWorker?.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage);
    };
  }, [soundUrl]);

  return null;
}
